import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "../ui/base/BaseElement";
import {
  observeContext,
  onEvent,
  SugarConfiguratorContext,
} from "./SugarConfiguratorContext";
import styles from "./SugarConfiguratorCSS";
import("../ui/FloatMenu");

@customElement("sugar-configurator-content")
@observeContext("model")
export class SugarConfiguratorContent extends BaseElement {
  static override styles = styles;
  private _context?: SugarConfiguratorContext;

  onContextChanged(context: any): void {
    this._context = context;
  }

  @onEvent("click")
  onClick(){
  }

  @property({ type: String, attribute: "type" })
  type: "editor" | "configurator" = "configurator";

  firstUpdated(e: any): void {
    super.firstUpdated(e);
    this._context?.start(this, this.type);
    this.setAttribute("mobiledragover", "");
    this.setAttribute("mobiledrop", "");
    this.classList.add("center");
    this.classList.add("dropArea");
  }

  protected renderHtml() {
    return html``;
  }
}
